<header
  class="absolute top-0 z-10 w-full bg-primary flex flex-col justify-end lg:justify-center drop-shadow-lg"
  [ngClass]="heightClass$ | async">
  <div class="pb-4 lg:pb-0 w-full" [ngClass]="(variant | async) === headerVariant.SMALL ? 'hidden lg:block' : ''"
       data-big-header-container>
    <app-container>
      <ul class="grid items-center grid-cols-8">
        <li class="col-span-full lg:col-span-5 flex items-center w-full">
          <a [routerLink]="'/'" class="hidden lg:inline-block">
            <img ngSrc="/svg/logo.svg" priority alt="Op Goeie Grond" height="37" width="44">
          </a>
          <app-search-bar class="w-full lg:pr-8 lg:pl-8" [ngClass]="(title | async) !== null ? 'hidden lg:block' : ''"/>
        </li>
        @if ((title | async) !== null) {
          <div class="lg:hidden col-span-full text-2xl font-bold text-secondary text-center font-secondary"
               data-header-title>{{ title | async }}</div>
        }
        <li
          class="hidden lg:block col-span-2">
          <a [routerLink]="'/kaart'"
             class="flex items-center justify-center text-sm xl:text-base text-white bg-primary-600 rounded-full px-2 py-2 font-secondary font-bold">
          <span class="relative mr-5">
            <ng-icon class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2" name="heroMap"
                     size="1.5rem" strokeWidth="1.5"></ng-icon>
            <ng-icon class="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"
                     name="heroMapPinSolid" size="0.3rem" strokeWidth="0.5"></ng-icon>
          </span>
            <span>Kaart bekijken</span>
          </a>
        </li>
        <li
          class="hidden lg:flex col-span-1 items-center gap-x-2 text-sm xl:text-base text-secondary font-secondary font-bold ml-4 justify-self-center"
          [routerLinkActive]="'w-fit border-b-2 border-secondary'">
          <ng-icon name="heroBars3" size="1.2rem" strokeWidth="1.7" class="mt-0.5"></ng-icon>
          <button (click)="openMenu()">Menu</button>
        </li>
      </ul>
    </app-container>
  </div>
</header>
